import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollCreateOrUpdatePerquisitesComponentResponse,
  PayrollUpdatePerquisitesComponentVariables,
} from './types';

export const editPerquisitesComponentMutation = gql`
  mutation PayrollUpdatePerquisiteComponents($components: [UpdatePerquisiteComponentInput!]!) {
    payrollUpdatePerquisiteComponents(components: $components) {
      code
      message
      success
      data {
        id
        name
        displayName
        description
        isSystemDefault
        status
        showZero
        visibleToEmployee
      }
    }
  }
`;

const editPerquisitesComponent = (queryVariables: PayrollUpdatePerquisitesComponentVariables) => {
  return graphQLApi<
    PayrollCreateOrUpdatePerquisitesComponentResponse,
    PayrollUpdatePerquisitesComponentVariables
  >({
    query: editPerquisitesComponentMutation,
    queryVariables,
  });
};

export default editPerquisitesComponent;
